<template>
  <div class="reopen-replay-modal">
    <el-dialog
      :title="$t('customerService.re_open_ticket')"
      :visible.sync="dialogUploadVisible"
      width="500px"
      :close-on-click-modal="false"
      class="diglog-card"
      @close="handleDialogClose"
      @open="handleDialogOpen"
    >
      <div class="header-line" />
      <div class="content">
        <el-form ref="form" label-width="170px" :model="form" :rules="rules" label-position="top">
          <el-row>
            <el-col :span="11">
              <el-form-item
                :key="form.operation_type"
                :label="$t('customerService.reply') + ':'"
                prop="conclusion"
                required
              >
              <el-input v-model="form.conclusion" style="width: 430px;min-height: 60px" class="input-conclusion" size="small" placeholder="Enter your message here" type="textarea"  clearable :maxlength="250" show-word-limit />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" style="display: flex">
              <div class="upload-label">
                <span class="upload-label-text">{{ $t('customerService.attachments') }}</span>
              </div>

              <el-upload
                action="#"
                :auto-upload="false"
                :file-list="form.attachmentList"
                :limit="3"
                :on-change="handleAttachmentChange"
                :on-exceed="handleExceed"
                :on-remove="handleAttachmentRemove"
                :disabled="uploadAttachmentLoading"
                :class="{'hideUploadFlag': isHideAttachmentUpdate,'upload-image':true}"
              >
                <div slot="default" class="upload-file-defaule" :loading="uploadAttachmentLoading">Click here to attach file</div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="dialog-footer">
        <!-- <el-button @click="dialogUploadVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submitLoading || uploadAttachmentLoading" class="btn-submit" @click="onClickSubmitBtn('form')">{{
          $t('components.submit')
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { reOpenTicket, ticketDetail } from '@/api/customer-service/customer-service'
import { uploadImg, uploadFile } from '@/api/components/upload'

export default {
  name: 'Reopen_Replay_Modal',
  props: {
    detailId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      uploadLoading: false,
      uploadAttachmentLoading: false,
      form: {
        attachmentList: [],
        attachmentMap: new Map()
      },
      ticketInfo:{},
      rules: {},
      dialogUploadVisible: false,
      submitLoading: false,
      dialogImageUrl: '',
      dialogImageVisible: false,
    }
  },
  computed: {
    isHideUpdate() {
      return this.form.fileList && this.form.fileList.length > 0
    },
    isHideAttachmentUpdate() {
      return this.form.attachmentList && this.form.attachmentList.length > 2
    }
  },
  methods: {
    initData() {
      this.uploadLoading = false
      this.uploadAttachmentLoading = false
      this.form = {
        attachmentList: [],
        attachmentMap: new Map()
      }
      this.dialogUploadVisible = false
      this.submitLoading = false
    },
    getDetailInfo() {
      ticketDetail({ id: this.detailId }).then(res => {
        this.ticketInfo = res.data
      })
    },
    handleDialogOpen() {
      this.getDetailInfo()
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    changModalStatus(value) {
      this.dialogUploadVisible = value
    },
    handleDialogClose() {
      this.initData()
      this.$refs['form'].clearValidate()
    },
    handleRemove(file) {
      this.form.fileList = this.form.fileList.filter(item => item.uid !== file.uid)
      this.form.pic_path = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    handleImageChange(file, fileList) {
      this.form.fileList = []

      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }

      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadImg(formData).then(res => {
        this.$message.success('Image upload successfully!')
        this.form.pic_path = res.data.path
        this.form.fileList = [file]
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    handleAttachmentChange(file, fileList) {
      this.form.attachmentList = fileList
      this.uploadAttachmentLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadFile(formData).then(res => {
        this.$message.success('File upload successfully!')
        this.form.attachmentMap.set(file.uid, file.name + ':' + res.data.path)
      }).catch(() => { // 上传失败移除预上传的文件
        this.form.attachmentList = this.form.attachmentList.filter(item => item.uid !== file.uid)
      }).finally(() => {
        this.uploadAttachmentLoading = false
      })
    },
    handleAttachmentRemove(file) {
      this.form.attachmentMap.delete(file.uid)
    },
    handleExceed() {
      this.$message.warning('Cannot upload more than 3 files')
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.uploadLoading) {
            this.$message.warning('Image uploading, please submit later!')
            return
          }

          const { conclusion, attachmentMap } = this.form

          const params =  { id: this.detailId,content:conclusion }

          if (attachmentMap) {
            var tmpList = []
            for (const item of attachmentMap.values()) {
              tmpList.push(item)
            }
            params.file_path = tmpList
          }
          this.submitLoading = true

          reOpenTicket(params).then(res => {
            this.$message.success({message:`Success, ${res.data.count} times Reopen left.`,duration: 5000})
            this.$emit('updateList')
            this.changModalStatus(false)
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
  }

}
</script>

<style>
.reopen-replay-modal .el-upload--picture-card{
  background-color: #fff;
  border: none;
  width: auto;
  height: auto;
  cursor: pointer;
  line-height: 1.2;
  text-decoration-line: underline;
  color: #3855F1;
}
 .content::-webkit-scrollbar{
    width:4px;
    /* height:2px; */
    /**/
  }
  .content::-webkit-scrollbar-track{
    background: #D2D8E3;
    border-radius:2px;
  }
  .content::-webkit-scrollbar-thumb{
    background: #98A1B4;
    border-radius:10px;
  }
  .content::-webkit-scrollbar-thumb:hover{
    background: #98A1B4;
  }
  .content::-webkit-scrollbar-corner{
    background: #179a16;
  }
</style>

<style scoped>
.upload-file-defaule{
  cursor: pointer;
  line-height: 1.2;
  text-decoration-line: underline;
  color: #3855F1;
}
.content{
  margin-top: 32px;
  padding-right: 20px;
  overflow: auto;
}
.icon-question{
  position: relative;
  top: -4px;
  margin-left: 5px;
  display: inline-block;
  height: 12px;
  width: 12px;

}

.input-base {
  width: 200px;
}

.input-url {
  width: 400px;
}

.search-btn {
  margin-left: 10px;
}

.upload-bill {
  width: 100px;
}
.upload-label{
  display: inline-block;
  width: 200px;
}
.upload-label-text{
  vertical-align: top;
  font-size: 14px;
  line-height: 1.2;
  color: #1D3A71;
}
.payment-receipt{
  display: inline-block;
  width: 150px;
  position: relative;
}
.image-only{
  position: absolute;
  top: 20px;
  left: -3px;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.2;
}
.payment-tip{
  position: relative;
  left: 19px;
  word-break: keep-all;
  line-height: 24px;
}
.upload-image{
  display: inline-block;
}
.dialog-footer{
  margin-top: 64px;
  text-align: center;
}
.btn-submit{
  width: 90%;
}
</style>
